<template>
  <div id="app">
    <a @click="Download()" class="toplink">
      <img src="./assets/open_app_top_kd.png">
    </a>
    <router-view/>
  </div>
</template>
<script>
export default {
  name:'app',
  methods:{
    Download(){
      let url = 'shenniao://app';
      setTimeout(()=>{
        location.href = 'http://img2.yitoutiao.net/app/download.html';
      },500)
      location.href = url;
    },
  }
}
</script>
<style>
  #app{ display: flex; position: fixed; width: 100%; height:100%; left: 0; top: 0; right: 0;bottom:0; flex-direction: column;
  }
.toplink{ width: 100%; }
.toplink img{ width: 100%; display: block; max-width: 640px;margin: auto}



</style>
